import { Grid } from '@material-ui/core';
import React from 'react';
import { getSingleAdminCompanyData } from 'Actions/adminActions';
import CloseBtn from '../CloseBtn';
import Logo from '../Logo/';
import { API_ROOT } from '../../../../../../../../api/Routes';
import styled from 'styled-components';
import Person from '@material-ui/icons/Person';
import connect from 'react-redux/es/connect/connect';
import API from './api';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Formik } from 'formik';
import makeSchema from './validationSchema';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';

const CompanyProfileWrapper = styled.div`
  width: 400px;
  min-height: 400px;
  overflow-x: hidden;
  background-color: #e0e1e0;
  padding: 40px;
`;
const EditProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
`;
const CompanyProfileTitle = styled.div`
  color: #61717a;
  font-size: 12px;
`;
const CompanyProfileValue = styled(Input)`
  color: #102027 !important;
  font-size: 14px !important;
`;
const CompanyProfileData = styled(Grid)`
  display: flex;
  padding: 20px;
`;
const CompanyProfileDataItem = styled(Grid)`
  &&& {
    margin-bottom: 12px;
  }
`;
const PersonIcon = styled(Person)`
  &&& {
    width: 11.5rem;
    height: 11.5rem;
    object-fit: cover;
  }
`;

const FieldError = styled.div`
  font-size: 0.75rem;
  color: red;
  font-weight: 300;
`;

// TODO: render inputs dynamically

class CompanyProfile extends React.Component {
  state = {
    open: false,
    message: '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.getSingleAdminCompanyData(this.props.companyId);
    }
  }

  componentDidMount() {
    this.props.getSingleAdminCompanyData(this.props.companyId);
  }

  makeInitialValues = data => {
    if (data.length === 0) return false;
    return {
      address: data.address,
      name: data.name,
      phone: data.phone,
      website: data.website,
      registeredCompanyNumber: data.registeredCompanyNumber,
    };
  };

  updateUser = values => {
    const companyId = this.props.currentCompany.companyId;
    const companyProfile = {
      companyName: values.name,
      officeAddress: values.address,
      phone: values.phone,
      website: values.website,
      registeredCompanyNumber: values.registeredCompanyNumber,
    };

    API.updateCompany(companyId, companyProfile)
      .then(res => {
        this.setState({
          message: 'Profile updated',
          open: true,
        });
      })
      .catch(err => {
        this.setState({
          message: 'Something went wrong',
          open: true,
        });
      });
  };

  handleChange = (setFieldValue, type) => e => {
    setFieldValue(type, e.target.value);
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  render() {
    const { onClose, currentCompany } = this.props;

    const values = this.makeInitialValues(currentCompany);
    return (
      <CompanyProfileWrapper>
        {values && (
          <Formik
            initialValues={values}
            enableReinitialize
            onSubmit={this.updateUser}
            validationSchema={values && makeSchema(values)}
          >
            {props => (
              <React.Fragment>
                <CloseBtn onClick={onClose} />
                {currentCompany && currentCompany.companyLogo ? (
                  <EditProfileWrapper>
                    <Logo
                      image={`${API_ROOT}/asset/${currentCompany.companyLogo}`}
                    />
                  </EditProfileWrapper>
                ) : (
                  <EditProfileWrapper>
                    <PersonIcon />
                  </EditProfileWrapper>
                )}
                <CompanyProfileData container spacing={8}>
                  <CompanyProfileDataItem item xs={6}>
                    <CompanyProfileTitle>Company name</CompanyProfileTitle>
                    <CompanyProfileValue
                      fullWidth
                      value={props.values.name}
                      onChange={this.handleChange(props.setFieldValue, 'name')}
                      name={'name'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.name && props.touched.name ? (
                      <FieldError>{props.errors.name}</FieldError>
                    ) : null}
                  </CompanyProfileDataItem>
                  <CompanyProfileDataItem item xs={6}>
                    <CompanyProfileTitle>Website</CompanyProfileTitle>
                    <CompanyProfileValue
                      fullWidth
                      value={props.values.website}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'website'
                      )}
                      name={'website'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.website && props.touched.website ? (
                      <FieldError>{props.errors.website}</FieldError>
                    ) : null}
                  </CompanyProfileDataItem>
                  <CompanyProfileDataItem item xs={6}>
                    <CompanyProfileTitle>Phone</CompanyProfileTitle>
                    <CompanyProfileValue
                      fullWidth
                      value={props.values.phone}
                      onChange={this.handleChange(props.setFieldValue, 'phone')}
                      name={'phone'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.phone && props.touched.phone ? (
                      <FieldError>{props.errors.phone}</FieldError>
                    ) : null}
                  </CompanyProfileDataItem>
                  <CompanyProfileDataItem item xs={6}>
                    <CompanyProfileTitle>Office address </CompanyProfileTitle>
                    <CompanyProfileValue
                      fullWidth
                      value={props.values.address}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'address'
                      )}
                      name={'address'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.address && props.touched.address ? (
                      <FieldError>{props.errors.address}</FieldError>
                    ) : null}
                  </CompanyProfileDataItem>
                  <CompanyProfileDataItem item xs={6}>
                    <CompanyProfileTitle>
                      Registered company number
                    </CompanyProfileTitle>
                    <CompanyProfileValue
                      fullWidth
                      value={props.values.registeredCompanyNumber}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'registeredCompanyNumber'
                      )}
                      name={'registeredCompanyNumber'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.registeredCompanyNumber &&
                    props.touched.registeredCompanyNumber ? (
                      <FieldError>
                        {props.errors.registeredCompanyNumber}
                      </FieldError>
                    ) : null}
                  </CompanyProfileDataItem>
                  <CompanyProfileDataItem item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={props.handleSubmit}
                      disabled={
                        this.props.currentCompany.ownerUserCompanyState !==
                        'ACTIVE'
                      }
                    >
                      SAVE
                    </Button>
                  </CompanyProfileDataItem>
                </CompanyProfileData>{' '}
                <Snackbar
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  open={this.state.open}
                  onClose={this.handleCloseSnack}
                  ContentProps={{
                    'aria-describedby': 'message-id',
                  }}
                  message={<span id="message-id">{this.state.message}</span>}
                  action={
                    <IconButton
                      key="close"
                      aria-label="Close"
                      color="inherit"
                      onClick={this.handleCloseSnack}
                    >
                      <CloseIcon />
                    </IconButton>
                  }
                />
              </React.Fragment>
            )}
          </Formik>
        )}
      </CompanyProfileWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSingleAdminCompanyData: companyId => {
    dispatch(getSingleAdminCompanyData(companyId));
  },
});
const mapStateToProps = store => {
  return {
    currentCompany: store.adminData.currentCompany,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfile);
